import React from 'react';
import PropTypes from 'prop-types';

function IconLock({ size = 16, className, style }) {
  return (
    <svg className={className} style={style} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 6H11V3.5C11 2.70435 10.6839 1.94129 10.1213 1.37868C9.55871 0.81607 8.79565 0.5 8 0.5C7.20435 0.5 6.44129 0.81607 5.87868 1.37868C5.31607 1.94129 5 2.70435 5 3.5V6H4.5C3.96974 6.00058 3.46137 6.21148 3.08643 6.58643C2.71148 6.96137 2.50058 7.46974 2.5 8V13.5C2.50058 14.0303 2.71148 14.5386 3.08643 14.9136C3.46137 15.2885 3.96974 15.4994 4.5 15.5H11.5C12.0303 15.4994 12.5386 15.2885 12.9136 14.9136C13.2885 14.5386 13.4994 14.0303 13.5 13.5V8C13.4994 7.46974 13.2885 6.96137 12.9136 6.58643C12.5386 6.21148 12.0303 6.00058 11.5 6ZM10 6H6V3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5C8.53043 1.5 9.03914 1.71071 9.41421 2.08579C9.78929 2.46086 10 2.96957 10 3.5V6Z" fill="white"/>
    </svg>
  )
}

IconLock.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconLock;
